module.exports = __webpack_public_path__ + "img/masterpro.e4dec7e.png";